































import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class Body extends Vue {
  relaxers = ["ASMR", "Hypnosis", "Talks", "Socializing", "Excercising", "Diet", "Music", "Nutrition", "Vacationing", "Adventuring", "Clubbing", ];
  enteringDialog = true;
  introSong: HTMLAudioElement | null = null;
  // all = { Affirmations: ["Love"], Nature: ["Nature"], MS13: ["MS13"] };
  all = {
    ASMR: [
      "Gibi",
      "Tingting",
      "GentleWhispering",
      "ASMRGlow",
      "PositiveAffirmation5",
    ],
    Hypnosis: [
      "Sealy",
      "UltraHypnosis",
      "HypnoticLabs",
      "NinjaHypnosis",
      "KimCarmen",
    ],
    Talks: ["PlumVillage", "Mooji"],
    Socializing: ["Meetup"],
    Excercising: ["OrangeTheory"],
    Diet: [""],
    Images: ["Nature1", "TypeBeat", "DogFlipBook", "Anime1FlipBook"],
  };
  content: { [key: string]: string } = {
    /// ASMR
    Gibi: "https://www.youtube.com/channel/UCE6acMV3m35znLcf0JGNn7Q",
    Tingting: "https://www.youtube.com/channel/UClqNSqnWeOOUVkzcJFj4rBw",
    GentleWhispering:
      "https://www.youtube.com/channel/UC6gLlIAnzg7eJ8VuXDCZ_vg",
    ASMRGlow: "https://www.youtube.com/channel/UCFmL725KKPx2URVPvH3Gp8w",
    // https://manofmany.com/entertainment/videos/best-asmr-artists-channels
    /// Hypnosis
    Sealy: "https://www.youtube.com/c/MichaelSealey/videos",
    UltraHypnosis: "https://www.youtube.com/user/UltraHypnosis/videos",
    HypnoticLabs:
      "https://www.youtube.com/channel/UCLs4IKoo9ByJ3IQS6u0pRRw/videos",
    NinjaHypnosis: "https://www.youtube.com/user/NimjaHypnosis/videos",
    KimCarmen: "https://www.youtube.com/user/FernberryHypnosis/videos",
    // https://blog.feedspot.com/hypnosis_youtube_channels/
    /// Talks
    PlumVillage: "https://www.youtube.com/plumvillage/videos",
    Mooji: "https://www.youtube.com/c/Moojiji",
    // Socializing
    Meetup: "https://www.meetup.com/home/?suggested=true&source=EVENTS",
    // Excercising
    OrangeTheory: "https://www.orangetheory.com/en-us/",
    //Diet
    //Music
    //Nutrition
    //Vacationing
    //Adventuring
    //Clubbing
    // KimCarmen: "https://www.youtube.com/user/FernberryHypnosis/videos",
    // KimCarmen: "https://www.youtube.com/user/FernberryHypnosis/videos",
    // KimCarmen: "https://www.youtube.com/user/FernberryHypnosis/videos",
    // KimCarmen: "https://www.youtube.com/user/FernberryHypnosis/videos",
    // KimCarmen: "https://www.youtube.com/user/FernberryHypnosis/videos",
  };

  onEnterVideo(): void {
    const video = document.getElementById("autoplay") as HTMLVideoElement;
    video.play();
    this.introSong = new Audio("./introSong.mp3");
    //   // this.bell.volume = 0.1
    // this.introSong!.play();
    this.enteringDialog = false;
  }

  playPause(): void {
    if (this.introSong?.paused) {
      this.introSong?.play()
    }
    else {
      this.introSong?.pause();
    }
  }

  mounted(): void {}
}
